import { EventEmitter, signal } from "@angular/core";

export var DATE_REGEX = 'dd/MM/yyyy, hh:mm a';
export var NAME_REGEX = '^[a-zA-Z ]*$';

export var MOBILE_REGEX = '^[1-9][0-9]*$';


export var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var SPACE_REGEX = /((?!.*[\s])(?=.*[A-Z])(?=.*\d))/;
export var Percentage_REGEX = /^([1-9]|[1-9][0-9]|100)$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#.()^+\-/|`'~{}:><=";_\[\]\\])[A-Za-z\d@$!%*?&#.()^+\-/|`'~{}:><=";_\[\]\\]{6,16}$/;

export let URL_REGEX = /^(http?|ftp|https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(app|com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;

export let facebook_REGEX = /((https):\/\/)(www\.)facebook\.com\/[a-zA-Z0-9.]{1,}/;
export let instagram_REGEX = /(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.]{1,30}\/?/
export let twitter_REGEX = /(https?:\/\/)?(www\.)?twitter\.com\/[A-Za-z0-9_]{5,15}(\?(\w+=\w+&?)*)?/
export let linkedIn_REGEX = /[(https:\/\/www\.linkedin.com)]{20}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/=]*)+/
export let youtube_REGEX = /(?:(?:https?:\/\/)(?:www)?\.?(?:youtu\.?be)(?:\.com)?\/(?:.*[=/])*)([^= &?/\r\n]{8,11})/
export let payLink = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
export var LIMIT = 10;

export var MAX_SIZE = 3;

export const noNumberRegExp = /^[a-zA-Z ]*$/;
export const NOT_ALLOW_SPACES = /^([0-9]+)$/
export const letterswithspace = /^[a-zA-Z][a-zA-Z\s]*$/;
export const alphaSpecialCharacters = /^[a-zA-Z_!@#$&()\\-`.+,/\"]*$/;

export const COLORS = [{ color: 'tag tag-default' }, { color: 'tag tag-azure' }, { color: 'tag tag-pink' }, { color: 'tag tag-gray' }, { color: 'tag tag-primary' },
{ color: 'tag tag-secondary' }, { color: 'tag tag-success' }, { color: 'tag tag-cyan' }, { color: 'tag tag-orange' }];


export function multiplyArray(arr: any, length: any) {
  return Array.from({ length }, () => arr).flat();
}

export function _clone(object: any): any {
  return JSON.parse(JSON.stringify(object));
}

export function _removeNullKeys(obj: any): any {
  Object.keys(obj).forEach((key) => (obj[key] == null) && delete obj[key]);
  return obj;
}

export function _dateTime24HoursList(): any {
  const currentDate = new Date();
  const dateTimeArray = [];
  for (let i = 0; i < 24; i++) {
    const hourDateTime = new Date(currentDate);
    hourDateTime.setHours(i, 0, 0, 0);
    dateTimeArray.push(hourDateTime);
  }
  return dateTimeArray;
}

let timerObject: any;
export const timerCount: EventEmitter<any> = new EventEmitter();
export function timer(time: any): any {
  let textSec: any = "0";
  let statSec: number = 30;
  timerObject = setInterval(() => {
    time.seconds--;
    if (statSec != 0) statSec--;
    else statSec = 59;
    if (statSec < 10) { textSec = "0" + statSec; }
    else textSec = statSec;
    if (time.seconds == 0) {
      clearInterval(timerObject);
      timerCount.emit(null);
    } else
      timerCount.emit(`${textSec}`);
  }, 1000);
}

export function _clearInterval(): any {
  clearInterval(timerObject);
}


export function modifyAppliedFiltersData(filtersList: any, appliedFilters: any) {
  return filtersList.reduce((acc: any, curr: any) => {
    const matchingChildren = curr.children.filter((child: any) => appliedFilters.includes(child.name));
    if (matchingChildren.length > 0) {
      acc[curr.name.toLowerCase()] = matchingChildren.map((child: any) => child.sId);
    }
    return acc;
  }, {});
}

export function phoneNumberPipe(value: any) {  // Eg. 4444-4444
  let phone: any;
  if (value != null) {
    const newVal = value.toString()
    const first = newVal.substring(0, 4)
    const last = newVal.substring(4, 8)
    phone = first + '-' + last
  }
  return phone;
}

export const statusData: { [key: number]: string } = {
  1: 'Invite sent',
  2: 'Invite resent',
  3: 'Active',
  4: 'Inactive',
  5: 'Pending',
  6: 'Update Request',
  7: 'Rejected'
};

export const statusDataCss: { [key: number]: string } = {
  1: 'bg-warning',
  2: 'bg-warning',
  3: 'bg-success',
  4: 'bg-default',
  5: 'bg-danger',
  6: 'bg-default',
  7: 'bg-default',
  8: 'bg-default',
};

export const businessTypes: { [key: number]: string } = {
  1: 'Restaurant',
  2: 'Cafe',
  3: 'Hotel',
};

export const orderStatuses: { [key: number]: string } = {
  1: 'New',
  2: 'Confirmed',
  3: 'Ready for Delivery',
  4: 'Picked Up',
  5: 'Out for Delivery',
  6: 'Delivered',
  7: "Completed",
  8: 'Replacement Requested',
  9: 'Resolution in progress',
  10: 'Cancelled',
  // 11: 'Declined by Delivery Agent',
  12: 'In Progress',
  13: 'Packed'
};


export const deliveryAgentOrderStatuses: { [key: number]: string } = {
  4: 'Picked Up',
  5: 'Out for Delivery',
};

export const deliveryAgentOrderHistoryStatuses: { [key: number]: string } = {
  6: 'Delivered',
  7: "Completed",
  8: 'Replacement Requested',
  10: 'Cancelled',
};

export const deliveryAgentPickupsStatuses: { [key: number]: string } = {
  1: 'Ready for pickup',
  2: 'Enroute for pickup',
};

export const deliveryAgentPickupsHistoryStatuses: { [key: number]: string } = {
  3: "Completed",
  4: 'Received in warehouse',
  5: 'Cancelled'
};


export const deliveryAgentStatus: { [key: number]: string } = {
  1: 'Invite sent',
  2: 'Invite resent',
  3: 'Active',
  4: 'Inactive'
};

export const userStatuses: { [key: number]: string } = {
  1: 'Invite sent',
  2: 'Invite resent',
  3: 'Active',
  4: 'Inactive'
};

export const datesFilter = [
  {
    id: "from",
    name: "From Date",
    sId: 'from',
  },
  {
    id: "to",
    name: "To Date",
    sId: "to",
  }
];


export const orderStatusCss: { [key: number]: string } = {
  1: 'bg-new-order',
  2: 'bg-confirmed-order',
  3: 'bg-ready-delivery-order',
  4: 'bg-pickedup-order',
  5: 'bg-out-for-delivery-order',
  6: 'bg-delivered-order',
  7: "bg-completed-order",
  8: 'bg-replacement-req-order',
  9: 'bg-replacement-req-approve-order',
  10: 'bg-cancelled-order',
  12: 'bg-in-progress-order',
  13: 'bg-packed-order'
};

export const quotationStatuses: { [key: number]: string } = {
  1: 'Pending',
  2: 'Sent',
  // 3: 'Rejected',
};

export const quotationStatusCss: { [key: number]: string } = {
  1: 'bg-danger',
  2: 'bg-warning',
  // 3: 'bg-warning',
};

export const ticketReplacementStatuses: { [key: number]: string } = {
  1: 'New',
  2: 'Approved',
  3: 'Cancelled',
};

export const ticketReplacementStatusCss: { [key: number]: string } = {
  1: 'bg-sky-blue',
  2: 'bg-success',
  3: 'bg-ticket-cancelled',
};

export function totalReplacementAmount(items: any) {
  return items.reduce((a: any, b: any) => a + b.calculatedPrice, 0);
}
export const pickupStatuses: { [key: number]: string } = {
  1: 'Ready for pickup',
  2: 'Enroute for pickup',
  3: 'Completed',
  4: 'Received in warehouse',
  5: 'Cancelled'
};

export const pickupStatusesCss: { [key: number]: string } = {
  1: 'bg-ready-for-pickup',
  2: 'bg-enroute-for-pickup',
  3: 'bg-completed-pickup',
  4: 'bg-recevied-in-warehouse',
  5: 'bg-pickup-cancelled'
};

export const ticketGeneralStatuses: { [key: number]: string } = {
  1: 'New',
  2: 'Inprogress',
  3: 'Closed',
};

export const ticketGeneralStatusCss: { [key: number]: string } = {
  1: 'bg-sky-blue',
  2: 'bg-warning',
  3: 'bg-ticket-cancelled',
};

export const invoiceStatus: { [key: number]: string } = {
  1: 'Paid',
  2: 'Unpaid',
  3: 'Partially Paid',
};
export const invoiceStatusCss: { [key: number]: string } = {
  1: 'bg-success',
  2: 'bg-danger',
  3: 'bg-warning',
};

export const inventoryStatus: { [key: number]: string } = {
  0: 'Enable',
  1: 'Less than 10',
  2: 'Disable',
};
export const inventoryStatusCss: { [key: number]: string } = {
  0: 'bg-success',
  1: 'bg-warning',
  2: 'bg-danger',
};
export const statusDatas: { [key: number]: string } = {
  1: 'Invite sent',
  2: 'Invite resent',
  3: 'Active',
  4: 'Inactive',
  5: 'Pending',
  6: 'Update Request',
  7: 'Rejected',
  8: 'Additional Info Required '
};
export const inventoryFilterStatus: { [key: number]: string } = {
  0: 'Enable',
  2: 'Disable',
};